import { render, staticRenderFns } from "./AdminContactsTable.vue?vue&type=template&id=0424340b&scoped=true"
import script from "./AdminContactsTable.vue?vue&type=script&lang=js"
export * from "./AdminContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424340b",
  null
  
)

export default component.exports